import http, { ResponseData } from './httpService'
import { IsaacTemplateMerchantResVO } from '../typings/promotionTypes'

export const reportSample = async (templateId: String): Promise<Map<String, any>> => {
  const { data } = await http.get<ResponseData<Map<String, any>>>('/fe/user/center/report/reportSample/' + templateId)
  return data.data
}

export const getPromotionReportsByPhone = async (phone: string): Promise<IsaacTemplateMerchantResVO[]> => {
  const { data } = await http.get<ResponseData<IsaacTemplateMerchantResVO[]>>(
    '/fe/user/center/template/merchant/listByPhone',
    {
      params: { phone },
    }
  )
  return data.data
}
